import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BohoCustomModal } from "../../../../Constant";
import { CUSTOM_MODAL_DATA } from "../../../../Data/UiKit/Modal";
import { ModalOne } from "./ProfileModal";
import ModalTwo from "./ResultModal";
import ModalThird from "./BalanceModal";

const BohoCustomModals = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={BohoCustomModal} span={CUSTOM_MODAL_DATA} />
        <CardBody>
          <Row className="g-3">
            <ModalOne/>
            <ModalTwo/>
            <ModalThird/>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BohoCustomModals;
